import { Component, Input } from '@angular/core';

@Component({
  selector: 'ui-fh-alert',
  templateUrl: './fh-alert.component.html',
  styleUrl: './fh-alert.component.scss'
})
export class FhAlertComponent {
  @Input() icon: string = '';
  @Input() text: string = '';
  @Input() type: 'PRIMARY' | 'DANGER' | 'BASIC' = 'BASIC';
}
